module.exports = __webpack_public_path__ + "img/alipay.c83c018e.png";